import { isFunction } from 'lodash';
import produce from '@cld/immer';

const DEFAULTS = {
  immer: true,
};

const throwNonFunctionReducer = (types, action) => {
  throw new Error(`Reducer must provide a function per type, found ${typeof types[action.type]} for type: ${action.type}`);
};

const createReducer = (types, initialState) => (state, action) =>
  types[action.type]
    ? isFunction(types[action.type])
      ? types[action.type](state || initialState, action)
      : throwNonFunctionReducer(types, action)
    : state || initialState;

const noOp = () => {};

const createImmerReducer = (types, initialState) =>
  produce(
    createReducer(
      types,
      //run an no-op produce to apply immer config on initial state (ex: deep freeze)
      produce(initialState, noOp)
    )
  );

export default (types, initialState, options = {}) => {
  options = { ...DEFAULTS, ...options };

  return options.immer ? createImmerReducer(types, initialState) : createReducer(types, initialState);
};
